import moment from "moment";
import { IntlShape } from "react-intl";
import { displaySnackBar } from "./snackBarUtils";
import { MESSAGE_TYPE } from "./constant";

export const isEmailValid = (email: string): boolean => {
  const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  return email !== undefined && regexEmail.test(email.trim());
};
export const getString = (name: string, isTitle?: boolean): string => {
  const limit = isTitle ? 25 : 15;
  if (name.length < limit) return name;
  else {
    let result = name.substring(0, limit);
    return (result += "...");
  }
};
export const isValidPassword = (password: string): boolean => {
  const result =
    /^(?=.*[a-z]){1}(?=.*[A-Z]){1}(?=.*[0-9]){1}(?=.*[!?éè.@#\$%\^&\*]){1}(?=.{8,})/.test(
      password,
    );
  return result;
};

export const isAdult = (birthday: Date): boolean => {
  return moment().diff(birthday, "years") >= 18;
};

export const isMaxDate = (dateArgs: Date): boolean => {
  const now = moment(new Date());
  const date = moment(dateArgs); // another date
  const duration = moment.duration(now.diff(date)).asDays();
  return duration > 0;
};

export const isNotValidCardNumber = (cardNumber: string) => {
  const _cn = cardNumber.replace(/ /g, "");
  return !cardNumber || isNaN(+_cn);
};

export const emptyInput = (client: any, intl: IntlShape, messageId: string) => {
  displaySnackBar(client, {
    type: MESSAGE_TYPE.ERROR,
    message: intl.formatMessage({ id: messageId }),
    isOpen: true,
  });
};

export const removeDuplicateArray = (documents: any[]) => {
  return documents.filter(
    (doc, index, self) => index === self.findIndex((t) => t.id === doc.id),
  );
};
